export function getErrorMessage(error) {
  const errorCodes = {
    'auth/credential-already-in-use':
      'The credential is already in use. The anonymous session can only be associated with a new account',
    'auth/email-already-in-use': 'Email is already in use',
    'auth/invalid-email': 'Invalid email',
    'auth/missing-email': 'Email is not registered',
    'auth/missing-password': 'Invalid password',
    'auth/popup-closed-by-user': 'The pop-up window has been closed by the user',
    'auth/too-many-requests': 'Too many requests have been made',
    'auth/user-disabled': 'The user is disabled',
    'auth/user-not-found': 'Email is not registered',
    'auth/weak-password': 'The password is too weak',
    'auth/wrong-password': 'Incorrect password',
    'credential-expired': 'The authentication token has expired',
    'auth/invalid-credential': 'The credentials entered are not valid',
  };

  const errorCode = error.code;

  if (typeof errorCode === 'string') {
    return errorCodes[errorCode] ?? 'An unknown error occurred';
  }

  const errorMessage = error.message;

  if (typeof errorMessage === 'string') return errorMessage;

  if (typeof error === 'string') return error;

  return `An unknown error occurred: ${error}`;
}
